<div class="row">
  <div class="col-lg-12">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-md-12 col-lg-12">
          <h4 class="text-uppercase">Device Distribution
          </h4>
          <div class="container-fluid" style="min-width: 600px;">
            <div class="row">
              <div class="col-md-12 col-lg-12" *ngIf="devicePieChartData?.length > 0">
                <app-pie-chart [data]="devicePieChartData" [height]="'400px'"></app-pie-chart>
              </div>
            </div>
            <div class="row table-header">
              <div class="col-4">
                <strong>Device Type</strong>
              </div>
              <div class="col text-right">
                <strong>Contribution %</strong>
              </div>
              <div class="col text-right">
                <strong>Masking %</strong>
              </div>
              <div class="col text-right">
                <strong>IVT %</strong>
              </div>
              <div class="col text-right">
                <strong>Viewability %</strong>
              </div>
            </div>
            <div class="row row-body" *ngFor="let dData of data?.deviceDistribution?.deviceTypes">
              <div class="col-4">{{dData.deviceType}}</div>
              <div class="col text-right">
                <ng-container *ngIf="!isFreemium">
                  {{dData.totalTrafficRatio | perc:'1.2-2'}}
                </ng-container>
                <ng-container *ngIf="isFreemium">
                  <div class="freemium-lock">
                    <i class="fa fa-lock"></i>
                  </div>
                </ng-container>
              </div>
              <div class="col text-right">
                <ng-container *ngIf="!isFreemium">
                  {{dData.maskingRatio | perc:'1.2-2'}}
                </ng-container>
                <ng-container *ngIf="isFreemium">
                  <div class="freemium-lock">
                    <i class="fa fa-lock"></i>
                  </div>
                </ng-container>
              </div>
              <div class="col text-right">
                <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                  {{dData.givtSivtRate | perc:'1.2-2'}}
                </ng-container>
                <ng-container *ngIf="isFreemium && !isFollowing">
                  <div class="freemium-lock">
                    <i class="fa fa-lock"></i>
                  </div>
                </ng-container>
              </div>
              <div class="col text-right">{{dData.nonGivtSivtViewability | perc:'1.2-2'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3" *ngIf="isFreemium || data?.deviceDistribution?.desktopData?.length > 0">
        <div class="col-md-12 col-lg-12">
          <h4 class="text-uppercase" id="domain-device-distribution-desktop">Desktop OS Distribution
          </h4>
          <div class="row">
            <div class="col-md-12 col-lg-12" *ngIf="desktopPieChartData?.length > 0">
              <app-pie-chart [data]="desktopPieChartData" [height]="'400px'"></app-pie-chart>
            </div>
          </div>
          <app-data-table-component [headers]="desktopHeaders" [currentSort]="'totalTrafficRatio'"
                                      [data]="desktopData"></app-data-table-component>
        </div>
      </div>
      <div class="row mt-3" *ngIf="isFreemium || data?.deviceDistribution?.mobileData?.length > 0">
        <div class="col-md-12 col-lg-12">
          <h4 class="text-uppercase" id="domain-device-distribution-mobile">Mobile OS Distribution
          </h4>
          <div class="row">
            <div class="col-md-12 col-lg-12" *ngIf="mobilePieChartData?.length > 0">
              <app-pie-chart [data]="mobilePieChartData" [height]="'400px'"></app-pie-chart>
            </div>
          </div>
          <app-data-table-component [headers]="mobileHeaders" [currentSort]="'totalTrafficRatio'"
                                    [data]="mobileData"></app-data-table-component>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #osTemplate let-item='item' let-row='row'>
  <img width="18" heigh="18" src="/assets/images/os_icon_{{ row.osShortName }}.png" alt="OS Icon"><span> {{ item }}</span>
</ng-template>

<ng-template #lockedTemplate>
  <div class="freemium-lock"><i class="fa fa-lock"></i></div>
</ng-template>

<ng-template #totalTrafficRatioTemplate let-item='item'>
  <span>{{ item | perc:'1.2-2' }}</span>
</ng-template>
